import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { PLYLoader } from "three/examples/jsm/loaders/PLYLoader";

const TreePointCloud = ({ url }) => {
    const canvasRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth / 2,
        height: window.innerHeight / 2,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth / 2,
                height: window.innerHeight / 2,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (!canvasRef.current) return;

        const scene = new THREE.Scene();
        scene.add(new THREE.AxesHelper());

        const camera = new THREE.PerspectiveCamera(
            75,
            windowSize.width / windowSize.height,
            0.1,
            1000,
        );

        const renderer = new THREE.WebGLRenderer({
            canvas: canvasRef.current,
        });

        renderer.setSize(windowSize.width, windowSize.height);

        const controls = new OrbitControls(camera, renderer.domElement);
        controls.update();

        const plyLoader = new PLYLoader();

        plyLoader.load(
            url,
            function (geometry) {
                const material = new THREE.PointsMaterial({
                    size: 0.01,
                    vertexColors: true,
                });

                const mesh = new THREE.Points(geometry, material);
                scene.add(mesh);

                setLoaded(true);
            },
            function (xhr) {
                const percent = (xhr.loaded / xhr.total) * 100;
                setProgress(percent);
            },
            function (error) {
                console.error("Error loading PLY file", error);
                setError("Failed to load PLY file.");
            },
        );

        camera.position.set(0, 0, 5);

        const animate = () => {
            requestAnimationFrame(animate);
            controls.update();
            renderer.render(scene, camera);
        };

        animate();

        return () => {
            renderer.dispose();
        };
    }, [url, windowSize]);

    return (
        <div>
            <canvas ref={canvasRef} />
            {loaded
                ? "The X axis is red. The Y axis is green. The Z axis is blue."
                : null}
            <br />
            {Math.round(progress)}% loaded
            <br />
            {error ? error : null}
        </div>
    );
};

export default TreePointCloud;
